import { TemplateType } from 'app/features/contest/models/contest-template.models';

export const dtnTemplate: TemplateType = {
  firstTable: [
    { id: 'position', label: 'Pos.' },
    { id: 'gender', label: 'Sexe' },
    { align: 'left', id: 'full_name', label: 'Nom' },
    { id: 'age', label: 'Age' },
    { id: 'metrics' },
    { id: 'customField' },
  ],
  hasTwoTables: true,
  header: {
    banner: 'assets/dtn-all.jpg',
    displayActivityInfo: false,
  },
  secondTable: [
    { id: 'date', label: 'Date' },
    { id: 'gender', label: 'Sexe' },
    { align: 'left', id: 'full_name', label: 'Nom' },
    { id: 'metrics' },
    { id: 'customField' },
  ],
  metrics: {
    available: ['ppr', 'wpk'],
    default: 'ppr',
  },
  theme: {
    primaryColor: '#001f2e',
    secondaryColor: '#003854',
    textColor: '#ffffff',
  },
};
